import type { QueryClient } from '@tanstack/react-query';
import type { InboxActionReceipt } from '../../shared/inbox-actions.ts';

/** Refresh canonical records. A receipt never creates a quote or marks crew acknowledgment locally. */
export async function applyInboxActionReceipt(
  client: QueryClient,
  receipt: InboxActionReceipt,
  scopeCurrent: () => boolean,
) {
  const keys =
    receipt.kind === 'visit_instruction'
      ? [
          ['visit-instructions', receipt.appointmentId],
          ['appointment', receipt.appointmentId],
          ['appointments'],
          ['schedule'],
          ['series'],
          ['crew-jobs'],
        ]
      : [['quotes'], ['quote', receipt.quoteId], ['customer-quotes']];
  // An older read held across approval must not restore its pre-approval instruction version.
  if (!scopeCurrent()) return;
  await Promise.all(keys.map((queryKey) => (scopeCurrent() ? client.cancelQueries({ queryKey }) : undefined)));
  if (!scopeCurrent()) return;
  await Promise.all(keys.map((queryKey) => (scopeCurrent() ? client.invalidateQueries({ queryKey }) : undefined)));
}
